import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AdminSubmenuComponent } from './components/administrator/admin-submenu/admin-submenu.component';


import { ProductosServiciosComponent } from './components/administrator/productos-servicios/productos-servicios.component';
import { NivelesCategoriaComponent } from './components/administrator/niveles-categorias/niveles-categorias.component';
import { BulkMembersComponent } from './components/administrator/bulk-members/bulk-members.component';

import { CompetitionsComponent } from './components/events-gestor/competitions/competitions.component';
import { EventsGestorComponent } from './components/events-gestor/events-gestor.component';
import { FinancialEventsComponent } from './components/financial-gestor/financial-events/financial-events.component';
import { FinancialGestorComponent } from './components/financial-gestor/financial-gestor.component';
import { FinancialVinculacionesComponent } from './components/financial-gestor/financial-vinculaciones/financial-vinculaciones.component';
import { ClubesComponent } from './components/gestor/clubes/clubes.component';

import { GestorSubmenuComponent } from './components/gestor/gestor-submenu/gestor-submenu.component';

import { MatriculasComponent } from './components/gestor/matriculas/matriculas.component';
import { SolicitudesComponent } from './components/gestor/solicitudes/solicitudes.component';

import { AdminRoleGuard } from './guards/admin-role.guard';
import { GestionRoleGuard } from './guards/gestion-role.guard';
import { gestorEventosGuard } from './guards/gestor-eventos.guard';
import { gestorFinancieroGuard } from './guards/gestor-financiero.guard';
import { NotFoundComponent } from './pages/error/not-found/not-found.component';
import { HomeComponent } from './pages/home/home.component';

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent, canActivate: [MsalGuard] },
  {
    path: 'admin',
    component: AdminSubmenuComponent,
    canActivate: [MsalGuard, AdminRoleGuard],
  },
  {
    path: 'admin/productos-servicios',
    component: ProductosServiciosComponent,
    canActivate: [MsalGuard, AdminRoleGuard],
  },
  {
    path: 'admin/niveles-categorias',
    component: NivelesCategoriaComponent,
    canActivate: [MsalGuard, AdminRoleGuard],
  },
  {
    path: 'admin/bulk-members',
    component: BulkMembersComponent,
    canActivate: [MsalGuard, AdminRoleGuard],
  },
  {
    path: 'gestor',
    component: GestorSubmenuComponent,
    canActivate: [MsalGuard, GestionRoleGuard],
  },
  {
    path: 'gestor/solicitudes',
    component: SolicitudesComponent,
    canActivate: [MsalGuard, GestionRoleGuard],
  },
  {
    path: 'gestor/vinculaciones',
    component: MatriculasComponent,
    canActivate: [MsalGuard, GestionRoleGuard],
  },
  {
    path: 'gestor/clubes',
    component: ClubesComponent,
    canActivate: [MsalGuard, GestionRoleGuard],
  },
  {
    path:'event-gestor',
    component:EventsGestorComponent,
    canActivate: [MsalGuard, gestorEventosGuard]
  },
  {
    path:'event-gestor/events',
    component:CompetitionsComponent,
    canActivate: [MsalGuard, gestorEventosGuard]
  },
  {
    path:'financial-gestor',
    component:FinancialGestorComponent,
    canActivate: [MsalGuard, gestorFinancieroGuard]
  },
  {
    path:'financial-gestor/events',
    component:FinancialEventsComponent,
    canActivate: [MsalGuard, gestorFinancieroGuard]
  },
  {
    path:'financial-gestor/vinculaciones',
    component:FinancialVinculacionesComponent,
    canActivate: [MsalGuard, gestorFinancieroGuard]
  },
  { path: '**', component: NotFoundComponent },
];
